export const motionProps = {
  initial: "hidden",
  whileInView: "visible",
  exit: "exit",
  viewport: { once: false, amount: 0.1 },
};
